import { type ReactNode } from "react";

interface FormFieldProps {
  label: string;
  required?: boolean;
  hint?: string;
  error?: string;
  children: ReactNode;
}

export function FormField({ label, required = false, hint, error, children }: FormFieldProps) {
  return (
    <label className="block">
      <span className="block text-sm font-medium text-on-surface mb-1">
        {label}
        {required && <span className="text-danger ml-0.5">*</span>}
      </span>
      {children}
      {hint && !error && <p className="mt-1 text-xs text-muted">{hint}</p>}
      {error && <p className="mt-1 text-xs text-danger">{error}</p>}
    </label>
  );
}

/** Text is 16 px below sm, where a phone browser zooms into any focused control
 * set smaller, and the box at least 44 px tall there, a phone's touch target
 * (the 16 px line alone leaves it at 42). Both tokens are max-sm: only, so from
 * sm the 14 px text, and any size a caller appends, stand as they were. */
export const inputClass =
  "w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm max-sm:text-base max-sm:min-h-11 dark:border-gray-600 dark:bg-gray-700 dark:text-white";
